export default __webpack_public_path__ + "static/media/dalen1big.b6f0171e.jpg";